function normalizeNumberString(string: string): string {
  const numString = string.replace(/\s+/gis, "");
  const firstComma = numString.indexOf(",");
  const firstDot = numString.indexOf(".");
  if (firstComma === -1 && firstDot === -1) {
    return numString;
  }
  if (firstComma !== -1 && firstDot !== -1) {
    const commaIsFirst = firstComma < firstDot;
    if (commaIsFirst) {
      return numString.replace(/,/g, "");
    } else {
      return numString.replace(/[.]/g, "").replace(",", ".");
    }
  }
  return numString.replace(",", ".");
}

export function parseAmount(s: string): number {
  return Number(normalizeNumberString(s));
}
